import callApi from '@/utils/callApi';
import state from '@/state';

const promises = [];
let isLoadingProfile = false;

export const fetchProfile = async() => {
  try {
    const res = await callApi('GET', '/v1/client/my-profile'); // @TODO use a lighter endpoint
    
    if (res.status === 401) {
      return null;
    }

    let resMerchantId = res.headers.get('X-GMF-Merchant-Id');
    if (resMerchantId) {
      resMerchantId = parseInt(resMerchantId);
    }
    if (resMerchantId && state.merchantId !== resMerchantId) {
      console.error(`Gamifiera widget error: Merchant ID mismatch
  The supplied customer token was generated for a different merchant.
  Merchant ID provided in widget configuration: ${state.merchantId}
  Merchant ID provided by the customer token: ${resMerchantId}`);
    }

    const profile = await res.json();

    return profile;
  } catch (e) {
    console.error('Error fetching profile', e);
    return null;
  }
}

export const getMyProfile = async () => {  
  if (isLoadingProfile) {
    return await ensureProfileLoaded(); 
  }

  isLoadingProfile = true;

  const profile = await fetchProfile();
  
  for (const resolve of promises) {
    resolve(profile);
  }

  promises.length = 0;
  isLoadingProfile = false;

  return profile;
}

export const ensureProfileLoaded = async () => {
  return new Promise((resolve) => {
    if (! isLoadingProfile) {
      return resolve();
    }

    promises.push(resolve);
  })
};

export default getMyProfile;